<template>
    <div class="conf">
      <div class="top-tips">注意：通用价格配置默认应用于全部{{priceConfName.name}}店铺，若存在店铺价格配置，对应店铺将优先应用店铺价格配置</div>
      <el-form label-width="20%">
        <el-form-item :label="`${priceConfName.sales}配置:`" label-width="100px">
          <el-radio-group v-model="salesPrice.way">
            <el-radio label="unity">
              取{{  priceConfName.name }}资料保存的{{ priceConfName.sales }}
            </el-radio>
            <br />
            <el-radio label="formula">
              按公式修改： 
              <!-- 当前价格 -->
              <el-select v-model="salesPrice.formulaValue.priceMultiplier" width="130px">
                  <el-option :label="priceConfName.name +  priceConfName.sales" value="now"></el-option>
                  <el-option label="基础资料销售价" value="base_sales"></el-option>
                  <el-option label="基础资料市场价" value="base_market"></el-option>
                  <el-option label="基础资料成本价" value="base_purchase"></el-option>
                  <el-option label="基础资料基本售价" value="base_base_selling"></el-option>
              </el-select>
               X
              <el-input-digit v-model.number="salesPrice.formulaValue.percentage" :precision="0" :max="999" nullable style="width: 80px">
                <span>%</span>
              </el-input-digit>
              +
              <el-input-digit v-model.number="salesPrice.formulaValue.addValue" :precision="2" nullable style="width: 80px">
                <span>元</span>
              </el-input-digit>
              -
              <el-input-digit v-model.number="salesPrice.formulaValue.subtractionValue" :precision="2" nullable style="width: 80px">
                <span>元</span>
              </el-input-digit>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" label-width="100px">
          <span>
            <span style="margin-left: 30px; font-size: 12px"> 分角处理：</span>
            <el-radio-group v-model="salesPrice.formulaValue.formula">
              <el-radio label="reserve">保留角和分 <span style="color: #aaa">(四舍五入)</span></el-radio>
              <el-radio label="erase_cent_dime">抹去分和角</el-radio>
              <el-radio label="erase_cent">抹去分</el-radio>
              <el-radio label="unity"
                >统一修改为xx.
                <el-input-digit
                  v-model.number="salesPrice.formulaValue.centDime1"
                  :precision="0"
                  :maxlength="1"
                  nullable
                  style="width: 30px"
                >
                </el-input-digit>
                <el-input-digit
                  v-model.number="salesPrice.formulaValue.centDime2"
                  :precision="0"
                  :maxlength="1"
                  nullable
                  style="width: 30px"
                >
                </el-input-digit>
                元
              </el-radio>
            </el-radio-group>
          </span>
        </el-form-item>
        <el-form-item label="" label-width="100px">
          <el-checkbox v-model="isIncr"
            >是否价格递增（为防止重复铺货，多店铺铺货可设置递增金额，按店铺顺序上架链接依次递增金额）</el-checkbox
          >
          <p v-if="isIncr" style="margin-left: 30px; font-size: 12px">
            递增金额：<el-input-digit v-model.number="salesPrice.incr" :precision="2" nullable style="width: 160px">
              <span>元</span>
            </el-input-digit>
          </p>
        </el-form-item>
        <el-form-item label="" label-width="100px" v-if="isDistributor">
          <el-checkbox v-model="salesPrice.isCalculateFreight">分销商品价格是否附加供销运费</el-checkbox>
          <div style="padding-left: 10px;" v-if="salesPrice.isCalculateFreight">
            <span style="color:#333;font-size:12px;">{{priceConfName.name}}价格 + 供销运费 X </span>
            <el-input-digit v-model.number="salesPrice.supplyFormulaValue.percentage" placeholder="请输入" nullable style="width: 60px">
              <span>%</span>
            </el-input-digit> + 
            <el-input-digit v-model.number="salesPrice.supplyFormulaValue.addValue" placeholder="请输入" nullable style="width: 60px">
              <span>元</span>
            </el-input-digit> -
            <el-input-digit v-model.number="salesPrice.supplyFormulaValue.subtractionValue" placeholder="请输入" nullable style="width: 60px">
              <span>元</span>
            </el-input-digit>
          </div>
        </el-form-item>

        <template v-if="priceConfName.market">
          <el-form-item :label="`${priceConfName.market}配置:`" label-width="100px">
            <el-radio-group v-model="marketPrice.way">
              <el-radio style="line-height: 30px" label="unity">
                取{{ priceConfName.name }}资料保存的{{ priceConfName.market }}
              </el-radio>
              <br />
              <el-radio label="formula">
                按公式修改： 
                <!-- 当前价格 -->
                <el-select v-model="marketPrice.formulaValue.priceMultiplier" width="130px">
                  <el-option :label="priceConfName.name +  priceConfName.sales" value="pdd_multi_price"></el-option>
                  <el-option :label="priceConfName.name + priceConfName.market" value="now"></el-option>
                  <el-option label="基础资料销售价" value="base_sales"></el-option>
                  <el-option label="基础资料市场价" value="base_market"></el-option>
                  <el-option label="基础资料成本价" value="base_purchase"></el-option>
                  <el-option label="基础资料基本售价" value="base_base_selling"></el-option>
                </el-select>
                X
                <el-input-digit v-model.number="marketPrice.formulaValue.percentage" :precision="0" :max="999" nullable style="width: 80px">
                  <span>%</span>
                </el-input-digit>
                +
                <el-input-digit v-model.number="marketPrice.formulaValue.addValue" :precision="2" nullable style="width: 80px">
                  <span>元</span>
                </el-input-digit>
                -
                <el-input-digit v-model.number="marketPrice.formulaValue.subtractionValue" :precision="2" nullable style="width: 80px">
                  <span>元</span>
                </el-input-digit>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" label-width="100px">
            <span>
              <span style="margin-left: 30px; font-size: 12px"> 分角处理：</span>
              <el-radio-group v-model="marketPrice.formulaValue.formula">
                <el-radio label="reserve">保留角和分 <span style="color: #aaa">(四舍五入)</span></el-radio>
                <el-radio label="erase_cent_dime">抹去分和角</el-radio>
                <el-radio label="erase_cent">抹去分</el-radio>
                <el-radio label="unity"
                  >统一修改为xx.
                  <el-input-digit
                    v-model.number="marketPrice.formulaValue.centDime1"
                    :precision="0"
                    :maxlength="1"
                    nullable
                    style="width: 30px"
                  >
                  </el-input-digit>
                  <el-input-digit
                    v-model.number="marketPrice.formulaValue.centDime2"
                    :precision="0"
                    :maxlength="1"
                    nullable
                    style="width: 30px"
                  >
                  </el-input-digit>
                  元
                </el-radio>
              </el-radio-group>
            </span>
          </el-form-item>
        </template>
      </el-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { cloneDeep } from 'lodash'
export default {
  props: {
    platform:{
      type:String,
      default:''
    },
    priceConfName:{
      type:Object,
      default:()=> {}
    },
    priceList: {
      type: Array,
      default: () => [],
    },
  },
  components:{
  },
  data() {
    return {
      salesPrice: {
        type: 'sales',
        way: 'unity',
        incr: '',
        formulaValue: {
          priceMultiplier: 'now',
          formula: 'reserve',
          percentage: 100,
          addValue: 0,
          subtractionValue: 0,
          centDime: '',
          centDime1: 0,
          centDime2: 0,
        },
        supplyFormulaValue:{
            priceMultiplier: 'now',
            formula: 'reserve',
            percentage: 100,
            addValue: 0,
            subtractionValue: 0,
            centDime: '',
        },
        isCalculateFreight:false, // 分销商品价格是否附加供销运费
      },
      marketPrice: {
        type: 'market',
        way: 'unity',
        incr: '',
        formulaValue: {
          priceMultiplier: 'now',
          formula: 'reserve',
          percentage: 100,
          addValue: 0,
          subtractionValue: 0,
          centDime: '',
          centDime1: 0,
          centDime2: 0,
        },
      },
      isIncr: false,
    };
  },
  watch: {
    priceList: {
      handler(v) {
        const list = cloneDeep(v)
        list.forEach(item => {
          item.formulaValue = {
            priceMultiplier: 'now',
            formula: 'reserve',
            percentage: 100,
            addValue: 0,
            subtractionValue: 0,
            centDime: '',
            ...item.formulaValue
          }
          let centDime1 = 0;
          let centDime2 = 0;
          if(typeof item.formulaValue.centDime === 'number'){
            if(item.formulaValue.centDime < 10){
              centDime1 = 0
              centDime2 = item.formulaValue.centDime
            }else{
              centDime1 = Math.floor(item.formulaValue.centDime / 10)
              centDime2 = item.formulaValue.centDime % 10
            }
          }
          if (item.type === 'sales') {
            this.salesPrice = {
              ...this.salesPrice,
              ...item,
              isCalculateFreight:!!item.isCalculateFreight,
              supplyFormulaValue:{
                ...item.supplyFormulaValue,
                addValue:item?.supplyFormulaValue?.addValue || 0,
                subtractionValue:item?.supplyFormulaValue?.subtractionValue || 0,
                percentage:item?.supplyFormulaValue?.percentage || 100,
                formula: item?.supplyFormulaValue?.formula || 'reserve',
              }
            };
            this.salesPrice.formulaValue.centDime1 = centDime1
            this.salesPrice.formulaValue.centDime2 = centDime2
            this.isIncr = !!this.salesPrice.incr;
          } else if (item.type === 'market') {
            this.marketPrice = {
              ...this.marketPrice,
              ...item,
            };
            this.marketPrice.formulaValue.centDime1 = centDime1
            this.marketPrice.formulaValue.centDime2 = centDime2
          }
        });
      },
    },
  },
  computed: {
    ...mapGetters(['isDistributor']),
  },
  methods: {
    getData() {
      const curPlatType = this.priceConfName;
      const list = [];
      const { centDime1,centDime2,...reset } = this.salesPrice.formulaValue
      const salesPrice = {
        ...this.salesPrice, 
        incr: this.isIncr ? this.salesPrice.incr : 0,
        isCalculateFreight:this.salesPrice.isCalculateFreight ? 1 : 0
      };
      salesPrice.formulaValue = {...reset,centDime: (centDime1 || 0) * 10 + (centDime2 || 0) };
      list.push(salesPrice);
      if (curPlatType.market) {
        const { centDime1,centDime2,...reset } = this.marketPrice.formulaValue
        list.push({...this.marketPrice,formulaValue:{...reset,centDime:(centDime1 || 0) * 10 + (centDime2 || 0) }});
      }
      return list;
    },
  },
};
</script>

<style lang="scss" scoped>
.top-tips{
  color: #ff3333;
  margin-bottom: 10px !important;
  padding-left: 45px;
}
</style>